
import { DocumentContentEditor } from "./DocumentContentEditor";

interface BusinessPlanViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function BusinessPlanView({ content, documentId, onUpdate }: BusinessPlanViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Executive Summary</h2>
        <DocumentContentEditor
          section="Executive Summary"
          content={content.executiveSummary}
          documentId={documentId}
          field="executiveSummary"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Business Description</h2>
        <DocumentContentEditor
          section="Business Description"
          content={content.businessDescription}
          documentId={documentId}
          field="businessDescription"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Market Analysis</h2>
        <DocumentContentEditor
          section="Market Analysis"
          content={content.marketAnalysis}
          documentId={documentId}
          field="marketAnalysis"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Organization & Management</h2>
        <DocumentContentEditor
          section="Organization & Management"
          content={content.organizationManagement}
          documentId={documentId}
          field="organizationManagement"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Service or Product Line</h2>
        <DocumentContentEditor
          section="Service or Product Line"
          content={content.serviceProductLine}
          documentId={documentId}
          field="serviceProductLine"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Marketing & Sales</h2>
        <DocumentContentEditor
          section="Marketing & Sales"
          content={content.marketingSales}
          documentId={documentId}
          field="marketingSales"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Funding Request</h2>
        <DocumentContentEditor
          section="Funding Request"
          content={content.fundingRequest}
          documentId={documentId}
          field="fundingRequest"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Financial Projections</h2>
        <DocumentContentEditor
          section="Financial Projections"
          content={content.financialProjections}
          documentId={documentId}
          field="financialProjections"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
